import React, { useState } from "react";
import clsx from "clsx";
import styles from './style.module.css';
 import SvgComponent from "./arrowSvg";
  


const CircleArrowButton  = ({size = "24px" , isOpen , onClick , style={}})=> {
  const [onHover, setOnHover] = useState(false);
    
    return <div onClick={onClick} style={{cursor:'pointer' , transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition:'0.3s' ,width:size , height:size , ...style}} >
      <SvgComponent size={24}  onMouseEnter={() => setOnHover(true)} onMouseLeave={() => setOnHover(false)} fill={onHover ? '#efefef' :"white"} />
    </div>
}

export default CircleArrowButton;

